/**
 * EsQuery
 * elasticsearch 拼装查询条件工厂类
 */
const esQuery = () => {
	const es = {};

	/**
	 * es查询条件拼装
	 */
	es.array = [];

	/**
	 * 降序
	 */
	es.desc = "desc";

	/**
	 * 升序
	 */
	es.asc = "asc";
	
	/**
	 * 过滤器：多个查询条件的完全匹配
	 */
	es.and = "must";

	/**
	 * 过滤器： 多个查询条件的相反匹配
	 */
	es.not = "must_not";

	/**
	 * 过滤器：至少有一个查询条件匹配
	 */
	es.or = "should";

	/**
	 * 适用的搜索类型：索引库字段类型为text的关键词查询
	 * fieldName 字段名，类型String
	 * fieldValue 字段值，类型String
	 * filter 过滤器，and:多个查询条件的完全匹配;
	 * 					   not:多个查询条件的相反匹配;
	 *                     or:至少有一个查询条件匹配
	 * @return  EsQuery
	 */
	es.addKeyword = function(fieldName,fieldValue,filter) {
        es.array.push({
            name: fieldName,
            value: fieldValue,
            filter: filter,
            type: 'match_phrase'
        })
		return this;
	}
	
	/**
	 * 适用的搜索类型：String类型精确匹配查询
	 * fieldName 字段名，类型String
	 * fieldValue 字段值，类型String
	 * filter 过滤器，and:多个查询条件的完全匹配;
	 * 					   not:多个查询条件的相反匹配;
	 *                     or:至少有一个查询条件匹配 
	 * isText 是否text类型，类型boolean
	 * @return  EsQuery
	 */
    es.addString = function(fieldName, fieldValue, filter, isText) {
	    es.array.push({
            name: isText ? fieldName + '.keyword' : fieldName,
            value: fieldValue,
            filter: filter,
            type: 'term'
        })
        return this;
    }
	
	/**
	 * 适用的搜索类型：数字，日期，布尔值精确匹配
	 * fieldName 字段名，类型String
	 * fieldValue 字段值，类型String
	 * filter 过滤器，and:多个查询条件的完全匹配;
	 * 					   not:多个查询条件的相反匹配;
	 *                     or:至少有一个查询条件匹配
	 * @return  EsQuery
	 */
	es.addNotString = function(fieldName,fieldValue,filter) {
        es.array.push({
            name: fieldName,
            value: fieldValue,
            filter: filter,
            type: 'term'
        })
		return this;
	}

	/**
	 * 适用的搜索类型：String类型模式匹配 ，其中?匹配任意字符，*匹配0个或多个字符。注意：可能会消耗非常多的资源，谨慎使用
	 * fieldName 字段名，类型String
	 * fieldValue 字段值，类型String
	 * filter 过滤器，and:多个查询条件的完全匹配;
	 * 					   not:多个查询条件的相反匹配;
	 *                     or:至少有一个查询条件匹配
	 * isText 是否是text类型，类型boolean
	 * @return  EsQuery
	 */
	 es.addPattern = function(fieldName,fieldValue,filter,isText) {
         es.array.push({
             name: isText ? fieldName + '.keyword' : fieldName,
             value: fieldValue,
             filter: filter,
             type: 'wildcard'
         })
		return this;
	}
	 
	/**
	 * 适用的搜索类型： 开头字符串 。注意：可能会消耗非常多的资源，谨慎使用
	 * fieldName 字段名，类型String
	 * fieldValue 字段值，类型String
	 * filter 过滤器，and:多个查询条件的完全匹配;
	 * 					   not:多个查询条件的相反匹配;
	 *                     or:至少有一个查询条件匹配
	 * isText 是否是text类型，类型boolean
	 * @return  EsQuery
	 */
	es.addStartWith = function(fieldName,fieldValue,filter,isText) {
        es.array.push({
            name: isText ? fieldName + '.keyword' : fieldName,
            value: fieldValue,
            filter: filter,
            type: 'prefix'
        })
		return this;
	}
	
	/**
	 * 适用的搜索类型：range 范围
	 * fieldName 字段名，类型String
	 * lt 小于，类型String
	 * lte 小于等于，类型String
	 * gt 大于，类型String
	 * gte 大于等于，类型String
	 * filter 过滤器，and:多个查询条件的完全匹配;
	 * 					   not:多个查询条件的相反匹配;
	 *                     or:至少有一个查询条件匹配
	 * @return  EsQuery
	 */
	es.addRange = function(fieldName,lt,lte,gt,gte,filter) {
		var obj = {
            name: fieldName,
            filter: filter,
            type: 'range'
        };
		if (lt != '' && lt != null) {
			obj.value1 = lt;
		}
		if (lte != '' && lt != null) {
            obj.value2 = lte;
		}
		if (gt != '' && gt != null) {
            obj.value3 = gt;
		}
		if (gte != '' && gte != null) {
            obj.value4 = gte;
		}
        es.array.push(obj)
		return this;
	}
	
	/**
	 * 适用的搜索类型：geo_point 位置距离搜索
	 * fieldName 字段名，类型String
	 * distance 距离指定坐标点的距离，类型String
	 * lat 指定点的纬度，类型String
	 * lon 指定点的经度，类型String
	 * filter 过滤器，and:多个查询条件的完全匹配;
	 * 					   not:多个查询条件的相反匹配;
	 *                     or:至少有一个查询条件匹配
	 * @return  EsQuery
	 */
	es.addGeoPoint = function(fieldName, distance,lat,lon,filter) {
        es.array.push({
            name: fieldName,
            value: distance,
            value1: lat,
            value2: lon,
            filter: filter,
            type: 'geo_point'
        })
		return this;
	}
	
	/**
	 *  适用的搜索类型：missing 查找文档中没有某个字段，或 字段值为NULL
	 * fieldName 字段名，类型String
	 * @return  EsQuery
	 */
	es.addMissing = function(fieldName) {
        es.array.push({
            name: fieldName,
            type: 'missing'
        })
		return this;
	}
	
	/**
	 *  适用的搜索类型：exists 查找文档中有某个字段，或 字段值不为NULL
	 * fieldName 字段名，类型String
	 * @return  EsQuery
	 */
	es.addExists = function(fieldName) {
        es.array.push({
            name: fieldName,
            type: 'exists'
        })
		return this;
	}

	/**
	 *  适用的搜索类型：全文检索，根据索引库中的所有属性
	 * keyword 搜索关键词，类型String
	 * @return  EsQuery
	 */
	es.addGlobal = function(keyword) {
        es.array.push({
            value: keyword,
            type: 'global'
        })
		return this;
	}
	/**
	 * 增加排序字段 
	 * fieldName 字段名，类型String
	 * orderType 排序类型 asc,desc
	 * isText 是否是text类型，类型boolean
	 * @return  EsQuery
	 */
	es.addSort = function(fieldName,orderType,isText) {
        es.array.push({
            name: isText ? fieldName + '.keyword' : fieldName,
            value: orderType,
            type: 'sort'
        })
		return this;
	}

    /**
     * 增加经纬度排序字段
     * fieldName 字段名，类型String
     * orderType 排序类型 asc,desc
     * lat 指定点的纬度，类型String
     * lon 指定点的经度，类型String
     * @return  EsQuery
     */
    es.addGeoSort = function(fieldName,orderType,lat,lon) {
        es.array.push({
            name: fieldName,
            value: orderType,
            value1: lat,
            value2: lon,
            type: 'geoSort'
        })
        return this;
    }
	
	/**
	 * 增加分页 
	 * from 从第几页开始 ，类型int
	 * size 返回文档数据量，类型int
	 * @return  EsQuery
	 */
	es.addPage = function(from,size) {
        es.array.push({
            value: from + ',' + size,
            type: 'page'
        })
		return this;
	}

    es.getArray = function() {
        return es.array;
    }

	return es;
}

export default esQuery